import CompanyGLCategoryList from "@/pages/components/manage/category/co-gl-cate/CompanyGLCategoryList";

export default {
  list: CompanyGLCategoryList,
};
